var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        "nudge-right": 40,
        "min-width": "290px",
        transition: "scale-transition",
        "close-on-content-click": false,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        dense: "",
                        "hide-details": "",
                        readonly: "",
                        value: _vm.displayValue,
                      },
                      scopedSlots: _vm._u(
                        [
                          !_vm.menu
                            ? {
                                key: "append-outer",
                                fn: function () {
                                  return [
                                    _vm.isActive
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "pointer",
                                            attrs: {
                                              color: !_vm.clearIconHovered
                                                ? "green"
                                                : "red",
                                            },
                                            on: {
                                              mouseenter: function ($event) {
                                                _vm.clearIconHovered = true
                                              },
                                              mouseleave: function ($event) {
                                                _vm.clearIconHovered = false
                                              },
                                              click: function ($event) {
                                                return _vm.clear()
                                              },
                                            },
                                          },
                                          [_vm._v("mdi-filter-remove")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-date-picker",
        {
          attrs: { range: _vm.isRange },
          model: {
            value: _vm.datesValue,
            callback: function ($$v) {
              _vm.datesValue = $$v
            },
            expression: "datesValue",
          },
        },
        [
          _c("v-spacer"),
          _c(
            "v-btn-toggle",
            {
              attrs: { mandatory: "", dense: "" },
              model: {
                value: _vm.modeSwitcherValue,
                callback: function ($$v) {
                  _vm.modeSwitcherValue = $$v
                },
                expression: "modeSwitcherValue",
              },
            },
            [
              _c("v-btn", [_c("v-icon", [_vm._v("mdi-calendar-start")])], 1),
              _c("v-btn", [_c("v-icon", [_vm._v("mdi-calendar-range")])], 1),
              _c("v-btn", [_c("v-icon", [_vm._v("mdi-calendar-end")])], 1),
            ],
            1
          ),
          _c("v-spacer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }